import { render } from "./ContentHeader.vue?vue&type=template&id=0a0e9805&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=ts"
export * from "./ContentHeader.vue?vue&type=script&lang=ts"

import "./ContentHeader.vue?vue&type=style&index=0&id=0a0e9805&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a0e9805"

export default script